import TanoProjo from './TanoProjo';
import { useEnvolPrenoms } from './useEnvolPrenoms';
import { QCM_GREEN, FONT_TITRE } from '../../utils/qcmTheme';

/** La consigne, en langue d'élève : le geste, pas « orientée ». */
export const CONSIGNE_SCAN = 'Levez vos cartes, bien droites, votre réponse en haut !';

/**
 * Taille des prénoms selon leur nombre : une classe entière doit tenir sur
 * l'écran sous la consigne, sans défilement, et rester lisible du fond.
 */
export const taillePrenoms = (nb) => {
  if (nb <= 12) return 'clamp(22px, 3vw, 48px)';
  if (nb <= 24) return 'clamp(20px, 2.4vw, 40px)';
  return 'clamp(16px, 1.9vw, 32px)';
};

/**
 * L'écran de scan de la projection (lot « levez vos cartes », 2026-09-19).
 *
 * Deux écrans distincts, décision du prof : pendant la réflexion, l'énoncé et
 * les choix, personne n'est nommé ; quand il ouvre le scan, l'énoncé s'en va et
 * il ne reste que la consigne et les prénoms en grand, qui s'envolent un à un
 * quand la carte est captée. Tout le monde lève au même signal, l'élève du
 * fond lit son prénom à six mètres et baisse sa carte dès qu'il s'envole.
 *
 * Mêmes entrées que `WaitingBand`, qui reste l'écran des séances dont le
 * serveur ne connaît pas encore l'ouverture du scan.
 */
const ScanScreen = ({ nonRepondants, complet, nbReponses, onReveal }) => {
  const pills = useEnvolPrenoms(nonRepondants);

  return (
    <div
      className="proj-fade-up flex-1 min-h-0 flex flex-col items-center justify-center text-white px-9 py-6 overflow-hidden"
      data-testid="ecran-scan"
    >
      {complet ? (
        <div className="flex items-center gap-6">
          <TanoProjo variant="entree" mood="joy" size={120} />
          <p
            className="proj-check-pop font-black"
            style={{ color: QCM_GREEN, fontSize: 'clamp(28px, 4vw, 56px)', fontFamily: FONT_TITRE }}
          >
            ✓ Toute la classe a répondu !
          </p>
        </div>
      ) : (
        <>
          <p
            className="font-black text-center leading-tight"
            style={{ fontSize: 'clamp(26px, 3.6vw, 54px)', fontFamily: FONT_TITRE, letterSpacing: '-.01em' }}
          >
            {CONSIGNE_SCAN}
          </p>
          <div className="flex flex-wrap justify-center gap-3 mt-8 w-full">
            {pills.map((p) => (
              <span
                key={p.code_aruco}
                className={`proj-name font-bold px-5 py-2.5 rounded-full whitespace-nowrap${p.bye ? ' proj-name-bye' : ''}`}
                style={{
                  background: 'rgba(255,255,255,.1)',
                  border: '1px solid rgba(255,255,255,.2)',
                  fontSize: taillePrenoms(nonRepondants.length),
                }}
              >
                {p.nom}
              </span>
            ))}
          </div>
        </>
      )}

      {nbReponses > 0 ? (
        <button
          type="button"
          onClick={onReveal}
          className="mt-8 text-[13px] font-bold px-4 py-2 rounded-full transition hover:bg-white/20"
          style={{ background: 'rgba(255,255,255,.1)', border: '1px solid rgba(255,255,255,.25)' }}
        >
          Révéler les réponses
        </button>
      ) : null}
    </div>
  );
};

export default ScanScreen;
